<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-i-lights-over-the-ocean">
<h1 style="margin-top: 150px">Part I<br/> Lights Over the Ocean</h1>
<blockquote>
<p style="text-align: right;"><em>“When I was a little boy I lived in an old house, and</em></p>
<p style="text-align: right;"><em>legend told us that a treasure was buried there…</em></p>
<p style="text-align: right;"><em>it cast an enchantment over that house. My home</em></p>
<p style="text-align: right;"><em>was hiding a secret in the depths of its heart…“</em><br/></p>
<p><br/></p>
<p style="text-align: right;"><em>Antoine de Saint-Exupery, The Little Prince</em></p>
</blockquote>
<p><em><br/>
</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?f11d81d0